import axios from "axios";
export const API_URL = "https://srinivasafleet.com/api";


const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const getVehicles = async (status = "active") => {
  const res = await api.get("/vehicles/", { params: { status } });
  return res.data;
};

export const getVehicleById = async (id) => {
  const res = await api.get(`/vehicles/${id}`);
  return res.data;
};

export const createVehicle = async (data) => {
  const res = await api.post("/vehicles/", data);
  return res.data;
};


export const uploadVehiclePhoto = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  const res = await api.post(
    "/vehicles/upload-photo",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return res.data;
};
export const updateVehicle = async (id, data) => {
  const res = await api.put(`/vehicles/${id}`, data);
  return res.data;
};

export const deleteVehicle = async (id) => {
  const res = await api.delete(`/vehicles/${id}`);
  return res.data;
};

export const bulkUploadVehicles = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const res = await api.post("/vehicles/bulk-upload", formData);
  return res.data;
};

export const getFinancialYears = async () => {
  const res = await api.get("/auth/financial-years");
  return res.data;
};

export const getServiceLocations = async () => {
  const res = await api.get("/vehicles/master/service-location");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getCompanies = async () => {
  const res = await api.get("/vehicles/master/company");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getVehicleMakes = async () => {
  const res = await api.get("/vehicles/master/vehicle-make");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getVehicleModels = async (makeId = null) => {
  const url = makeId
    ? `/vehicles/master/vehicle-model?make_id=${makeId}`
    : "/vehicles/master/vehicle-model";
  const res = await api.get(url);
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getFuelTypes = async () => {
  const res = await api.get("/vehicles/master/fuel-type");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getFuelIssues = async () => {
  const res = await api.get("/vehicles/master/fuel-issue");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getStatuses = async () => {
  const res = await api.get("/vehicles/master/status");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getTransmissionTypes = async () => {
  const res = await api.get("/vehicles/master/transmission-type");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getTaxStatuses = async () => {
  const res = await api.get("/vehicles/master/tax-status");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getSuppliers = async () => {
  const res = await api.get("/vehicles/master/supplier");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};

export const getSupplierTypes = async () => {
  const res = await api.get("/suppliers/master-supplier-type");
  return Array.isArray(res.data) ? res.data : res.data.data ?? [];
};